import api from "app/api";
import { Options } from "common";
import { BookingOptionItem } from "features/booking-options/bookingOptionApi";
import { EventItem, EventOption } from "features/events/eventApi";
import { OptionGroupItem } from "features/option-groups/optionGroupApi";
import { OptionItem } from "features/options/optionApi";
import { PartnerItem } from "features/partners/partnerApi";
import { ProgramVariantItem } from "features/program-variants/programVariantApi";
import { BOOKING_PAY_LOCATIONS, BOOKING_STATUSES } from "./bookingConstants";
export interface BookingItem {
  id: number;
  booking_number: string;
  external_booking_number?: string;
  event_id: number;
  event?: EventItem;
  program_variant_id: number;
  program_variant?: ProgramVariantItem;
  custom_partner: boolean;
  partner_name: string;
  partner_id: number;
  partner?: PartnerItem;
  status: BOOKING_STATUSES;
  name: string;
  email: string;
  phone: string;
  number_of_adults: number;
  number_of_kids: number;
  number_of_babies: number;
  number_of_guests: number;
  number_of_guides: number;
  paid: boolean;
  check_in_at: string;
  armband_at: string;
  description: string;
  sku: string;
  adult_price: number;
  kid_price: number;
  price: number;
  planned: boolean;
  planned_event_id: number;
  planned_event: EventItem;
  planned_datetime: string;
  estimated_start_time: string;
  table_numbers: string;
  upgrade_price?: number | null;
  upgrade?: boolean;
  refund_amount?: number | null;
  upgrade_payable?: boolean;
  upgrade_paid?: boolean;
  voucher?: string;
  pay_location?: BOOKING_PAY_LOCATIONS;
  booking_options?: BookingOptionItem[];
  created_at: string;
  deleted_at?: string;
  payment_options?: {
    payment_method: string;
    transaction_id: string;
    discount_total: number;
    curency: string;
    kid_price: number;
    adult_price: number;
    admin_fee: number;
  };
  admin_fee: number;
  lang: string;
  currency: string;
  source_id: number;
  source?: PartnerItem;
  should_notify?: boolean;
  notify_description?: string;
}
//Add database attributes
export type ExtendedEventOption = OptionItem & EventOption;

export type BookingOptionGroupItem = {
  items: ExtendedEventOption[];
} & OptionGroupItem;

export type BookingOptions = Options<"role" | "status" | "partner_id">;

export function getBookingService(scope?: any, customScope?: string) {
  return api.getService<BookingItem, BookingItem, BookingOptions>("bookings", {
    scope,
    itemExporter(data) {
      if (data?.email) {
        data.eamil = data.email.trim();
      }
      if (!!data?.name) {
        data.name = data.name.trim();
      }
      if (!!data?.partner_name) {
        data.partner_name = data.partner_name.trim();
      }
      return data;
    },
    urlParams: customScope ? { scope: customScope } : undefined,
    //params goes here
  });
}
export function bookingSearch(params?: any) {
  return api.get<BookingItem[]>("bookings/search", {
    params,
  });
}
export function setTableNumbers(id: any, tableNumbers: string[] | null) {
  return api.post<BookingItem>(`bookings/${id}/set-table-numbers`, {
    tableNumbers,
  });
}
export function checkIn(id: any) {
  return api.post<BookingItem>(`bookings/${id}/check-in`);
}
export function checkOut(id: any) {
  return api.post<BookingItem>(`bookings/${id}/check-out`);
}
export function registerArmband(id: any) {
  return api.post<BookingItem>(`bookings/${id}/register-armband`);
}
export function cancelArmband(id: any) {
  return api.post<BookingItem>(`bookings/${id}/cancel-armband`);
}

export function cancelBookingsByIds(bookingIds?: any[]) {
  return api.post<{ count: number }>(`booking/cancel`, {
    bookingIds,
  });
}

export function getUpgradeVariants(id: any) {
  return api.get<ProgramVariantItem[]>(`bookings/${id}/upgrade-variants`);
}

export type UpgradeItem = Partial<BookingItem>;
export function upgrade(id: any, item: UpgradeItem) {
  return api.post<ProgramVariantItem[]>(`bookings/${id}/upgrade`, item);
}
